import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => { setDebounced(value); }, delayMs);
    return () => { window.clearTimeout(id); };
  }, [value, delayMs]);
  return debounced;
}
